import { render, staticRenderFns } from "./OfflineWarning.vue?vue&type=template&id=a57bbbea&scoped=true&"
import script from "./OfflineWarning.vue?vue&type=script&lang=js&"
export * from "./OfflineWarning.vue?vue&type=script&lang=js&"
import style0 from "./OfflineWarning.vue?vue&type=style&index=0&id=a57bbbea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57bbbea",
  null
  
)

/* custom blocks */
import block0 from "./OfflineWarning.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports